import { render, staticRenderFns } from "./footCommunity.vue?vue&type=template&id=76c34a42&scoped=true&"
import script from "./footCommunity.vue?vue&type=script&lang=js&"
export * from "./footCommunity.vue?vue&type=script&lang=js&"
import style0 from "./footCommunity.vue?vue&type=style&index=0&id=76c34a42&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c34a42",
  null
  
)

export default component.exports